import type { TelemetryPort } from '@/domain/telemetry/TelemetryPort'
import type { TelemetryEvent } from '@/domain/telemetry/types'

/**
 * Adapter that delegates to a transport ONLY when consent is true.
 * Drops every event otherwise (ADR-024 — opt-in default off).
 *
 * The consent function is called per emit so a runtime toggle takes
 * effect immediately — no need to rebuild the adapter when the user
 * flips the switch on /privacy.
 *
 * Production wiring (slice 5.3+): the delegate is
 * {@code HttpTelemetryAdapter}. Tests can wire any port — the
 * adapter knows nothing about the transport.
 */
export class ConsentingTelemetryAdapter implements TelemetryPort {
  private readonly delegate: TelemetryPort
  private readonly isConsenting: () => boolean

  constructor(delegate: TelemetryPort, isConsenting: () => boolean) {
    this.delegate = delegate
    this.isConsenting = isConsenting
  }

  emit(event: TelemetryEvent): void {
    if (!this.isConsenting()) return
    this.delegate.emit(event)
  }
}
